// import { Component, OnInit, ElementRef } from '@angular/core';

// @Component({
//   selector: 'app-crowdiff',
//   templateUrl: './crowdiff.component.html',
//   styleUrls: ['./crowdiff.component.scss'],
// })
// export class CrowdiffComponent implements OnInit {
//   constructor(private elementRef: ElementRef) { }

//   ngOnInit() {
//     this.loadScripts();
//   }
//   loadScripts(): void {
//     const lang = localStorage.getItem('language') || 'en';
//     const body = this.elementRef.nativeElement.querySelector('.one');
//     const script = document.createElement('script');
//     script.innerHTML = '';
//     script.src = 'https://starling.crowdriff.com/js/crowdriff.js';
//     script.async = true;
//     script.defer = true;
//     script.id = 'cr-init__f72c80bc28dabb31';
//     script.lang = lang.toLowerCase();
//     body.appendChild(script);
//   }
// }

import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-crowdiff',
  templateUrl: './crowdiff.component.html',
  styleUrls: ['./crowdiff.component.scss'],
})
export class CrowdiffComponent implements OnInit, OnDestroy {
  private loadMoreInterval: any;
  private langSubscription!: Subscription;

  constructor(private elementRef: ElementRef, private translate: TranslateService) {}

  ngOnInit(): void {
    this.loadScripts();

    const currentLang = this.translate.currentLang || localStorage.getItem('language') || 'EN';

    this.translateLoadMore(currentLang);

    // Listen for language changes
    this.langSubscription = this.translate.onLangChange.subscribe((event: { lang: string }) => {
      this.translateLoadMore(event.lang);
    });
  }

  loadScripts(): void {
    const lang = localStorage.getItem('language') || 'EN';

    const body = this.elementRef.nativeElement.querySelector('.one');

    if (!body) {
      return;
    }

    const script = document.createElement('script');

    script.src = 'https://starling.crowdriff.com/js/crowdriff.js';

    script.async = true;
    script.defer = true;

    script.id = 'cr-init__f72c80bc28dabb31';

    script.lang = lang.toLowerCase();

    body.appendChild(script);
  }

  translateLoadMore(lang: string): void {
    const language = (lang || 'EN')
      .trim()
      .split(/[\s(-]/)[0]
      .toLowerCase();

    const translations: { [key: string]: string } = {
      en: 'Load More',
      fr: 'Charger plus',
      de: 'Mehr laden',
      it: 'Carica altro',
      es: 'Cargar más',
      pt: 'Carregar mais',
      ru: 'Загрузить ещё',
      zh: '加载更多',
      hi: 'और देखें',
      ja: 'もっと見る',
      ar: 'تحميل المزيد',
    };

    const translatedText = translations[language] || translations.en;

    if (this.loadMoreInterval) {
      clearInterval(this.loadMoreInterval);
    }

    let attempts = 0;

    this.loadMoreInterval = setInterval(() => {
      const elements = this.elementRef.nativeElement.querySelectorAll('.loadMore__text');

      if (elements.length > 0) {
        elements.forEach((element: HTMLElement) => {
          element.textContent = translatedText;
        });

        clearInterval(this.loadMoreInterval);
      }

      attempts++;

      if (attempts >= 20) {
        clearInterval(this.loadMoreInterval);
      }
    }, 500);
  }

  ngOnDestroy(): void {
    if (this.loadMoreInterval) {
      clearInterval(this.loadMoreInterval);
    }

    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }
}
